/**
 * Claims Dashboard Helper — Orchestration Module
 *
 * Re-exports all helper symbols from their dedicated sub-modules
 * so existing consumers can keep importing from this single file.
 */

// --- Role & status config ---
// --- Table columns ---
import {
  getColumnsForRole,
  setColumnRefs
} from './helperModules/claimTableColumns';

// --- Table action buttons & actions column ---
import {
  claimsDashboardTableActionConfig,
  actionsColumn,
  setActionRefs
} from './helperModules/claimTableActions';

export {
  CLAIM_STATUS_RANK,
  claimRoleTypes,
  getClaimRole,
  canCreateClaim
} from './helperModules/claimRoleConfig';
export { getColumnsForRole };
export { claimsDashboardTableActionConfig };

// --- Shared mutable refs (role, reasonList, action handlers) ---
const currentRoleRef = { value: 'CLAIM_DESK' };
const reasonListRef = { value: [] };
const claimActionHandlersRef = { value: {} };

// Wire refs into sub-modules
setColumnRefs(currentRoleRef, reasonListRef, claimActionHandlersRef);
setActionRefs(currentRoleRef, claimActionHandlersRef);

// --- Public API for setting shared state ---

export const setClaimsReasons = reasons => {
  reasonListRef.value = reasons || [];
};

export const setClaimsDashboardActionHandlers = actionHandlers => {
  claimActionHandlersRef.value = {
    openViewModal: actionHandlers.openViewModal,
    openInfoModal: actionHandlers.openInfoModal,
    openRoleAction: actionHandlers.openRoleAction,
    toggleRowSelection: actionHandlers.toggleRowSelection,
    isRowSelected: actionHandlers.isRowSelected,
    toggleAllSelection: actionHandlers.toggleAllSelection,
    isAllSelected: actionHandlers.isAllSelected
  };
};

export const claimsDashboardTableConfig = {
  columns: getColumnsForRole('CLAIM_DESK').concat(actionsColumn),
  className: 'zoomTableLegacyWrapper claimsTableWrapper'
};

export const setClaimsDashboardConfig = claimRole => {
  currentRoleRef.value = claimRole;
  claimsDashboardTableActionConfig.currentRole = claimRole;
  claimsDashboardTableConfig.columns = getColumnsForRole(claimRole).concat(
    actionsColumn
  );
};
